import React, { FC } from 'react';
import styled from 'styled-components';
import { Colors } from '../../styles/colors';
import { Navigation, INavigationItem } from './Navigation';
import { MetaNavigation, MetaNavItem } from './MetaNavigation';
import { MobileNavigation } from './MobileNavigation';
import { PopupOverlay } from './PopupOverlay';
import { useRecoilState } from 'recoil';
import { MobileNavigationState } from '../../state/MobileNavigationState';
import { BoxedContainer as ContainerBase } from './Layout';

const HeaderWrapper = styled.header`
  position: relative;
  height: 7rem;
  background-color: ${Colors.white};
  padding: 1rem 2rem;
`;

const StickyHeader = styled.div`
  position: fixed;
  z-index: 50;
  top: 0;
  left: 0;
  right: 0;
  height: 7rem;
  background-color: ${Colors.white};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const BoxedContainer = styled(ContainerBase)`
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

const Backdrop = styled(PopupOverlay)`
  z-index: 49;
`;

export interface HeaderProps {
  onSearchClick?: () => void;
  items: INavigationItem[];
  appName: string;
  userDropDownItems?: MetaNavItem[];
  interceptLogout?: (continueLogout: () => void) => Promise<boolean>;
  onHeaderLogoClick?: () => void;
}

export const Header: FC<HeaderProps> = (props) => {
  const { onSearchClick, items, appName, userDropDownItems, interceptLogout, onHeaderLogoClick } = props;
  const [showMobileNavigation, setShowMobileNavigation] = useRecoilState<boolean>(MobileNavigationState);

  return (
    <>
    <HeaderWrapper>
      <StickyHeader>
        <BoxedContainer>
          <MetaNavigation onSearchClick={onSearchClick} userDropDownItems={userDropDownItems} interceptLogout={interceptLogout} />
          <Navigation appName={appName} items={items} onHeaderLogoClick={onHeaderLogoClick} />
          <MobileNavigation items={items} />
        </BoxedContainer>
      </StickyHeader>
    </HeaderWrapper>
    {
      showMobileNavigation &&
      <Backdrop {...{ open: showMobileNavigation }} onClick={() => setShowMobileNavigation(false)} />
    }
    </>
  );
}
;
